import { __assign, __extends } from "tslib";
import { namespacedClassnames } from '../../common/namespace-classes';
import * as React from 'react';
// import { Tooltip} from '../tooltip/tooltip';
import { InfoTooltip } from '../info-tooltip/info-tooltip';
var SimpleCSSTooltip = /** @class */ (function (_super) {
    __extends(SimpleCSSTooltip, _super);
    function SimpleCSSTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleCSSTooltip.prototype.render = function () {
        var props = this.props;
        var namespaceClass = namespacedClassnames('simple-tooltip-container', props.className);
        var position = props.position || 'below';
        var delay = props.delay || 'normal';
        var infoTooltip = props.infoTooltip ? 'info-tooltip' : '';
        var classes = namespaceClass + " " + position + " " + delay + "-delay " + infoTooltip;
        return (React.createElement("div", { className: classes, "data-content": props.text }, this.props.children));
    };
    return SimpleCSSTooltip;
}(React.Component));
export { SimpleCSSTooltip };
export var SimpleTooltip = function (props) {
    var oldCSSTooltip = (React.createElement(SimpleCSSTooltip, __assign({}, props)));
    // const newTooltip = (
    // 	<Tooltip body={props.text}>
    // 		{props.children}
    // 	</Tooltip>
    // );
    return oldCSSTooltip;
};
export var SimpleInfoTooltip = InfoTooltip;
//# sourceMappingURL=simple-tooltip.js.map